import makeStyles from '@mui/styles/makeStyles';
import Drawer from '@mui/material/Drawer';
import { useEffect, useState } from 'react';
import NRHelpDrawerStyles from './NRHelpDrawer.styles';
import NRHelpDrawerKnob from './NRHelpDrawerKnob/NRHelpDrawerKnob';
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import ChevronRightOutlinedIcon from '@mui/icons-material/ChevronRightOutlined';
import { useMatches } from 'react-router-dom';
import Markdown from 'react-markdown';
import 'github-markdown-css';

const useStyles = makeStyles(NRHelpDrawerStyles);

function NRHelpDrawer({ knobDistanceFromTop = '450px', knobOpenLabel, knobCloseLabel }) {
  const classes = useStyles();
  const [isOpen, setIsOpen] = useState(false);
  const matches = useMatches();

  // Find the last matched route that has `displayHelpDrawer` set
  const matchedWithHelp = [...matches].reverse().find(match => match.handle?.displayHelpDrawer && match.handle?.helpDrawerContent);

  const displayHelpDrawer = !!matchedWithHelp;
  const helpDrawerContent = matchedWithHelp?.handle?.helpDrawerContent;

  function handleKnobClick(value) {
    setIsOpen(value);
  }

  return (
    <>
      {displayHelpDrawer && (
        <>
          <NRHelpDrawerKnob
            isOpen={isOpen}
            onclick={handleKnobClick}
            top={knobDistanceFromTop}
            label={knobOpenLabel || <HelpOutlineOutlinedIcon />}
          />
          <Drawer
            classes={{ paper: classes.drawerPaper }}
            anchor={'right'}
            open={isOpen}
            onClose={() => setIsOpen(false)}
            onKeyDown={event => {
              if (event.key === 'Escape') {
                setIsOpen(false);
              }
            }}
          >
            <div className={classes.mainContainer}>
              <NRHelpDrawerKnob
                isOpen={isOpen}
                onclick={handleKnobClick}
                top={knobDistanceFromTop}
                label={knobCloseLabel || <ChevronRightOutlinedIcon />}
              />
              <div className={classes.helpContent}>
                <div className="markdown-body">
                  <Markdown>{helpDrawerContent}</Markdown>
                </div>
              </div>
            </div>
          </Drawer>
        </>
      )}
    </>
  );
}

export default NRHelpDrawer;
